import { render, staticRenderFns } from "./AdminPanos.vue?vue&type=template&id=171ccd75&scoped=true"
import script from "./AdminPanos.vue?vue&type=script&lang=js"
export * from "./AdminPanos.vue?vue&type=script&lang=js"
import style0 from "./AdminPanos.vue?vue&type=style&index=0&id=171ccd75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171ccd75",
  null
  
)

export default component.exports